import CardsViewContainer from "../../Componant/JobSearch/CardsView";

const CardsView = () => {
  return (
    <div className="page-body">
      <CardsViewContainer />
    </div>
  );
};

export default CardsView;
